/**
 * Set season of the current page to store
 */
export default {
    created() {
        this.$store.commit('setCurrentSeason', this.season);
    },
};
